$(document).ready(function () {
  function getWorldTime(tzOffset) {
    var now = new Date();
    var tz =
      now.getTime() + now.getTimezoneOffset() * 60000 + tzOffset * 3600000;
    now.setTime(tz);

    var s =
      leadingZeros(now.getFullYear(), 4) +
      "-" +
      leadingZeros(now.getMonth() + 1, 2) +
      "-" +
      leadingZeros(now.getDate(), 2) +
      " " +
      leadingZeros(now.getHours(), 2) +
      ":" +
      leadingZeros(now.getMinutes(), 2) +
      ":" +
      leadingZeros(now.getSeconds(), 2);

    return s;
  }

  function leadingZeros(n, digits) {
    var zero = "";
    n = n.toString();

    if (n.length < digits) {
      for (i = 0; i < digits - n.length; i++) zero += "0";
    }
    return zero + n;
  }

  var now_addr = window.location.href;
  var preview = now_addr.split("?preview=");
  var preview_ = now_addr.split("&preview=");
  
  
    // 프로모션 js start
    var promotionEvent = (getWorldTime(+9) > "2026-09-11 00:00:00" && getWorldTime(+9) < "2026-09-16 02:00:00") || (window.location.href.includes('preview=true'));

    if (promotionEvent) {
        // 상세페이지 안내 문구
        $('.product-form__buttons').before(`
            <p style="margin-top: 20px; font-size: 18px; color: #f00;line-height: 1;word-break: keep-all;">We’re moving our warehouse! Orders placed Sep 11-14 will ship starting Sep 14. We appreciate your patience. Your order will ship as soon as we’re back up and running.</p>
        `)

        // /* 메인 슬라이드: 미국 물류 창고 이관 */
        if ($(".main_slide").length > 0) {

            $('.main_slide .swiper-slide.prmBannerShort').show();
            $('.main_slide .swiper-slide.prmBannerShort').removeClass('displaynone');

            // prmBannerShort를 제외한 나머지 슬라이드 전부 제거
            $('.main_slide .swiper-slide').not('.prmBannerShort').remove();

            // 이전/다음 버튼 숨김 처리
            $('.main_slide .swiper-button-prev').hide();
            $('.main_slide .swiper-button-next').hide();

            if (typeof main_bnr !== "undefined") {
            main_bnr.updateSlides();
            main_bnr.update();
            }
        }

        // 띠문구 추가
        $('.announcement-bar .slider--everywhere').prepend(`
            <div class="promotion_bnr slideshow__slide slider__slide grid__item grid--1-col">
            <p class="announcement-bar__message h5">
                <span>Delayed: Sep 11–14 orders ship Sep 14</span>
            </p>
            </div>
        `);
        
    }else{
    $('.main_slide .swiper-slide.prmBannerShort').remove();
    }
    // 프로모션 js end

});
